"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAttachmentRateLimitEvaluator = void 0;
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const formula_engine_1 = require("@finley-technologies/formula-engine");
const attachmentRateLimitExcelEngineEvaluator = (params) => {
    const { formulas, f1EngineMode } = params;
    let excelEngine = null;
    const initializeEngine = (initializeParams) => {
        const { sanitizedReceivables } = initializeParams;
        excelEngine = (0, formula_engine_1.initializeExcelEngine)({
            data: sanitizedReceivables,
            formulas,
            f1EngineMode,
        });
    };
    const tearDownEngine = () => {
        if (excelEngine) {
            excelEngine.clearSheet();
        }
    };
    const evaluateConfig = (evaluateParams) => {
        (0, common_1.finleyAssert)(excelEngine, 'Attachment Rate Limit ExcelEngine is not set. Make sure to initialize first before evaluating');
        const { formula } = evaluateParams;
        const attachmentRateLimit = excelEngine.evaluateNumber(formula);
        return { attachmentRateLimit };
    };
    return { initializeEngine, tearDownEngine, evaluateConfig };
};
const createAttachmentRateLimitEvaluator = (params) => {
    const { classDetails, f1EngineMode } = params;
    (0, common_1.finleyAssert)(classDetails.length > 0, 'Received empty class details when attempting to create attachment rate limit evaluator');
    // Enforcing that each Class Details has the same type and config set up so we can
    // evaluate all of them with the same mechanics / engine.
    // This will always be the case at the moment since there's only a single option
    // that we default these attributes to (UI doesn't provide any way to adjust).
    // Will need to revisit this validation / mechanics if we support more configs
    // and allow each class detail to have independent configs
    const classDetailTypeSet = new Set();
    const classDetailConfigEngineSet = new Set();
    for (const classDetail of classDetails) {
        const { type, config } = classDetail.attachmentRateLimit._config_;
        classDetailTypeSet.add(type);
        classDetailConfigEngineSet.add(config.engineVersion);
    }
    (0, common_1.finleyAssert)(classDetailTypeSet.size === 1 && classDetailConfigEngineSet.size === 1, `Expected same config structure across Class Details when setting up Attachment Rate Limit evaluator [types:${Array.from(classDetailTypeSet).join(', ')}] [configs:${Array.from(classDetailConfigEngineSet).join(', ')}]`);
    // Use 1st instance since we know they all have the same type / config set up
    const { attachmentRateLimit } = classDetails[0];
    const { type, config } = attachmentRateLimit._config_;
    switch (type) {
        case 'formula':
            switch (config.engineVersion) {
                case finley_types_1.FormulaEngine.FullSupportedFormulaEngines.ExcelEngine1:
                    return attachmentRateLimitExcelEngineEvaluator({
                        formulas: classDetails.map((item) => item.attachmentRateLimit._config_.config.formula),
                        f1EngineMode,
                    });
                case finley_types_1.FormulaEngine.FullSupportedFormulaEngines.HyperFormula1:
                    // This should technically not be possible as we currently default to
                    // ExcelEngine and user has no way of setting to be a different engine
                    throw new common_1.error.FinleyError('HyperFormula engine version is not supported for Attachment Rate Limit formula evaluation');
                default:
                    return (0, common_1.finleyAssertUnreachable)(config.engineVersion);
            }
        default:
            return (0, common_1.finleyAssertUnreachable)(type);
    }
};
exports.createAttachmentRateLimitEvaluator = createAttachmentRateLimitEvaluator;
//# sourceMappingURL=attachmentRateLimitEvaluator.js.map